// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeLastPeriodsBulkResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/employee_last_periods_bulk
 * Returns a map of "user_id|franchise_id" → last period end date (ISO datetime string or null)
 *
 * The dados shape is a dynamic map keyed by composite ids ("user_id|franchise_id"),
 * not a fixed-shape object — frontend looks up by `${user_id}|${franchise_id}`.
 * Keys are runtime-constructed; the value type is concrete: ISO 8601 UTC datetime or null.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_EmployeeLastPeriodsBulkResponseDados = Record<string, string | null>;

export type Payroll_EmployeeLastPeriodsBulkResponse = ApiResponse<Payroll_EmployeeLastPeriodsBulkResponseDados>;

registerResponseContract('Payroll_EmployeeLastPeriodsBulkResponse', {})
